import { api } from '@/shared/api/client';
import type { PaymentClaim, RecordPaymentPayload, RecordPaymentResult, ReceiptUrlOut } from './types';

export const paymentApi = {
  record: (payload: RecordPaymentPayload) =>
    api.post<RecordPaymentResult>('/api/v1/payments', payload),
  get: (id: string) => api.get<PaymentClaim>(`/api/v1/payment-claims/${id}`),
  confirm: (id: string) => api.post<void>(`/api/v1/payment-claims/${id}/confirm`, {}),
  reject: (id: string) => api.post<void>(`/api/v1/payment-claims/${id}/reject`, {}),
  requestReceipt: (id: string) =>
    api.post<void>(`/api/v1/payment-claims/${id}/request-receipt`, {}),
  uploadReceipt: (claimId: string, file: File) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.upload<{ attachment_id: string }>(`/api/v1/payment-claims/${claimId}/receipt`, formData);
  },
  getReceipt: (claimId: string) =>
    api.get<ReceiptUrlOut>(`/api/v1/payment-claims/${claimId}/receipt`),
};
